export enum ArticleType {
  STORABLE,
  CONSUMABLE
}
